import { FC } from "react";
import { HTMLProps } from "utils/HTMLProps";
import { WithStyle } from "utils/WithStyle";
import { ContentWrapper } from "./Content.styled";

const Component: FC<HTMLProps<HTMLDivElement>> = ({ children }) => {
    return <ContentWrapper>{children}</ContentWrapper>;
};

export const Content: FC<HTMLProps<HTMLDivElement>> & WithStyle = Object.assign(
    Component,
    {
        Style: ContentWrapper,
    }
);
